import { ChiptaElement, html } from 'chipta-libs/main.js';
import onSmallScreen from 'chipta-libs/utils/on-small-screen.js';
import './font-awesome.js';
import './ticketshop-menu.js';

class TicketshopHeader extends ChiptaElement {

  static get properties() {
    return {
      headertext: {type: String},
      nopadding: {type: Boolean}
    };
  }

  render() {

    return html`

      <header style=${this.headerStyle}>

        <div id="header-background" style=${this.headerBackgroundStyle}>

          <div id="header-content">

            <div id="menu-container">
              <ticketshop-menu></ticketshop-menu>
            </div>

            <div id="header-text-container" style=${this.headerTextContainerStyle}>
              ${this.headerEl}
            </div>

          </div>

        </div>

      </header>

      <div id="first-section-contents" ?nopadding=${this.nopadding}>
        <slot></slot>
      </div>

      <style>

        :host {
          display: block;
        }

        * {
          box-sizing: border-box;
        }

        header {
          display: flex;
          flex-direction: column;
        }

        #header-background {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          width: 100%;
        }

        #header-content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0 auto;
          width: 100%;
          max-width: ${_themeData.max_width};
        }

        #menu-container {
          margin-bottom: 25px;
        }

        #header-text-container {
          padding: 10px 20px;
          line-height: 45px;
          min-height: 65px;
          background: white;
          border-bottom: 1px solid #D9D9D9;
          text-transform: ${_themeData.header_text_transform};
        }

        #header-text {
          margin: 0;
          font-weight: 600;
          font-size: 26px;
        }

        #first-section-contents {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: ${_themeData.max_width};
          margin: 0 auto;
          padding: 0 20px 20px;
          background: white;
          -webkit-box-shadow: 0px 4px 8px 0px #CCC;
          -moz-box-shadow: 0px 4px 8px 0px #CCC;
          box-shadow: 0px 4px 8px 0px #CCC;
        }

        @media screen and (max-width: 500px) {

          :host {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          #header-text {
            font-size: 20px;
            line-height: 35px;
          }

          #header-content {
            max-width: 100%;
          }

          #header-text-container {
            padding-left: 10px;
            padding-right: 10px;
            min-height: 56px;
          }

          #first-section-contents {
            flex-grow: 1;
            padding: 0;
            max-width: 100%;
          }

        }

      </style>

    `;

  }

  get headerStyle() {

    let style = '';

    if (_themeData.header_image) {

      const minHeight = () => {
        if (onSmallScreen()) {
          return 200;
        } else {
          return 250;
        }
      };

      style += 'min-height: ' + minHeight() + 'px;';

    } else {
      style += (
        'background-color: ' + _themeData.header_color + ';'
        + 'min-height: 125px;'
      );
    }

    return style;

  }

  get headerBackgroundStyle() {

    if (_themeData.header_image) {
      return (
        'background-image: url("' + _themeData.header_image + '");'
        + 'background-size: cover;'
        + 'background-position: center;'
      );
    }

    return '';

  }

  get headerTextContainerStyle() {

    if (_themeData.header_image) {
      return 'background-color: #FFFC;';
    }

    return '';

  }

  get headerEl() {
    if (this.headertext) {
      return html`<h1 id="header-text">${this.headertext}</h1>`;
    } else {
      return html`<font-awesome icon="circle-notch"></font-awesome>`;
    }
  }

}

customElements.define('ticketshop-header', TicketshopHeader);
